// Runtime API configuration
// Uses window.location.origin so the app works on ANY domain (preview, production, custom)
// without needing build-time environment variables

const getBaseUrl = () => {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const BACKEND_URL = getBaseUrl();
export const API = `${getBaseUrl()}/api`;
